import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { DuplcateAction as DuplicateAction, Qualification, QualificationResponse } from '@interfaces'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class QualificationService {
	private http = inject(HttpClient)
	url = '/customers/cualifications'

	// Estos enumerados se mantienen hasta que se cree un endpoint en el backend que los devuelva
	// Son las acciones que pueden elegirse en el control de duplicados
	multipleDuplicateAction: DuplicateAction[] = [
		{
			name: 'COMBINE',
			value: 'combine'
		},
		{
			name: 'UPDATE_LAST',
			value: 'update last'
		},
		{
			name: 'ADD_NEW_DATA',
			value: 'add new data'
		}
	]

	singleDuplicateAction: DuplicateAction[] = [
		{
			name: 'COMBINE',
			value: 'combine'
		},
		{
			name: 'ADD_NEW_DATA',
			value: 'add new data'
		}
	]

	// Convierte el objeto respuesta de la cualificación al objeto que se utiliza en
	// su pantalla correspondiente y que se envía al back para actualizar
	convertToQualification(response: QualificationResponse): Qualification {
		const qualification: Qualification = {
			id: response.id,
			nameContact: response.nameContact,
			surnameContact: response.surnameContact,
			addressContact: response.addressContact,
			countryContact: response.countryContact,
			docNumberContact: response.docNumberContact,
			birthDateContact: response.birthDateContact,
			countryEnterprise: response.countryEnterprise,
			docNumberEnterprise: response.docNumberEnterprise,
			tradenameEnterprise: response.tradenameEnterprise,
			duplicateContactEmail: response.duplicateContactEmail,
			duplicateContactMobile: response.duplicateContactMobile,
			emailContact: response.emailContact,
			mobileContact: response.mobileContact,
			singleDuplicateAction: response.singleDuplicateAction ? response.singleDuplicateAction.name : undefined,
			multipleDuplicateAction: response.multipleDuplicateAction ? response.multipleDuplicateAction.name : undefined
		}
		return qualification
	}

	// Obtiene los datos de la cualificación
	getQualification(): Observable<QualificationResponse> {
		return this.http.get<QualificationResponse>(`${this.url}`)
	}

	// Actualiza los datos de la cualificación
	putQualification(qualification: Qualification): Observable<QualificationResponse> {
		return this.http.put<QualificationResponse>(`${this.url}`, qualification)
	}
}
